// extracted by mini-css-extract-plugin
export var auto = "_3t-1";
export var spinner = "_3t-0";